import type { RoomPageConfig } from '../types'
import { useRoomTheme } from './roomTheme'

/** The client's logo in each version the page was baked with. */
export type RoomLogos = Pick<RoomPageConfig, 'logoUrlOnLight' | 'logoUrlOnDark'>

interface RoomLogoProps {
    logos: RoomLogos
    companyName: string
}

/**
 * The client's logo made for the background the room's theme draws it on: the light version in the light theme, the
 * dark one in the dark theme. A brand with no logo for that background shows the company's name in its place.
 */
export function RoomLogo({ logos, companyName }: RoomLogoProps) {
    const { theme } = useRoomTheme()
    const logoUrl = theme === 'dark' ? logos.logoUrlOnDark : logos.logoUrlOnLight
    if (logoUrl) return <img src={logoUrl} alt={companyName} />
    return <span class="nm">{companyName}</span>
}
